import { createPageSegmentLoadMetric } from '@confluence/browser-metrics/entry-points/metricConfigs';
import { GLOBAL_NAVIGATION_SEGMENT_KEY } from '@confluence/browser-metrics/entry-points/metric-keys';

import { ssrConfig } from '../ssrConfig';

export const GLOBAL_NAVIGATION_METRIC = createPageSegmentLoadMetric({
	key: GLOBAL_NAVIGATION_SEGMENT_KEY,
	ssr: ssrConfig(),
});
